import { TabPageDefinition } from '@/components/tab-pages';

type AvailableTabs = 'Past payments' | 'Guideline';

export const paymentsTabs = (selectedTab?: AvailableTabs): TabPageDefinition[] => {
  return [
    {
      label: 'Past payments',
      linkProps: {
        to: '/payments',
      },
      isSelectedTab: selectedTab === 'Past payments' || !selectedTab,
      dataTestId: 'payments-past-payments-tab',
    },
    {
      label: 'Guideline',
      linkProps: {
        to: '/payments/guideline',
      },
      isSelectedTab: selectedTab === 'Guideline',
      dataTestId: 'payments-guideline-tab',
    },
  ];
};
